var _circle, _path, _circle2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoSessions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 50.8a16.5 16.5 0 0116.5 0 16.5 16.5 0 0116.5 0M21.5 27A16.5 16.5 0 0138 27a16.5 16.5 0 0116.5 0m-33 0v23.8M38 27v23.8M54.5 27v23.8",
    stroke: "#121738",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 66,
    r: 12,
    fill: "#E84848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4 71.2A3.8 3.8 0 0161 69a6 6 0 01-.5-2.5c0-1 .2-1.9.5-2.6a3.7 3.7 0 013.4-2.2 3.7 3.7 0 013.4 2.2c.3.7.5 1.6.5 2.6s-.2 1.8-.5 2.5-.8 1.2-1.4 1.6c-.6.4-1.2.6-2 .6zm0-1.8c.6 0 1-.3 1.3-.7a4 4 0 00.5-2.3 4 4 0 00-.5-2.2c-.3-.4-.7-.7-1.3-.7-.5 0-1 .3-1.3.7-.3.5-.5 1.3-.5 2.3 0 1 .2 1.7.5 2.2.3.4.8.7 1.3.7z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSessions);
export default __webpack_public_path__ + "static/media/no-sessions.b2d99bd1ca12773124324644568d732c.svg";
export { ForwardRef as ReactComponent };